import * as types from './types';

const authReducerDefault = {
  authenticated: false,
  name: null,
  username: null,
  firstName: null,
  lastName: null,
  email: null,
  phoneNumber: null,
  groupId: null,
  gitlab_id: null,
  role: null,
  status: null,
  customerid: ""
};

const authReducer = (state = authReducerDefault, action) => {
  //console.log(`action is ---${action.type}${action.payload}`);
  switch (action.type) {
    case types.LOGIN_REQUEST:
      //console.log('action is: ' + action);
      return {
        ...state
      };
    case types.LOGIN_SUCCESS:
      // console.log('action is: ' + action);
      return {
        ...state,
        authenticated: true,
        username: action.payload.data.username,
        name: action.payload.data.name,
        email: action.payload.data.email,
        groupId: action.payload.data.groupId,
        gitlab_id: action.payload.data.gitlab_id,
        role: action.payload.data.role,
        status: action.payload.data.status,
        customerid : action.payload.data.customerid
      };
    case types.LOGIN_ERROR:
      return {
        ...state,
        authenticated: false,
        username: null,
        email: null
      };
    case types.LOGOUT_SUCCESS:
       return {
         ...state,
         authenticated: false,
         name: null,
         username: null,
         firstName: null,
         lastName: null,
         email: null,
         phoneNumber: null,
         groupId: null,
         gitlab_id: null,
         role: null,
         status: null
       };

    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/state/auth/reducer.js